import { useContext, useState} from 'react';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import C from "helpers/HelpConstants";
import { HelpAbility } from "helpers/HelpAbility";
import DireccionContext from 'context/DireccionContext';
import {Modal, ListGroup} from "react-bootstrap";

let myAbilities = HelpAbility();

function Item({setSelectedDireccion, getVinculedClients, setModalVincularCliente, i, direccion: direc, deleteDireccion }) {
    const { setDireccion } = useContext(DireccionContext);
    const { _id, mailClient, alias, barrio, codCiudad, codDepartamento, direccion, direccionID, esDireccionPredeterminada, observacion,
        tipoDireccionID, calle, carrera, numero, tipoInmueble, numeroTipoInmueble, bloqueInterior, numeroBloqueInterior, codigoDireccionMER, tipoDireccionMER } = direc;
    const [modalMoreInfoDirection, setModalMoreInfoDirection] = useState(false);

    const handleIsUpdateForm = () => {
        setDireccion({ ...direc })
    }

    const handleDeleteDireccion = async () => {
        deleteDireccion({ id: _id })
    }

    const handleLinkClient = async () => {
        setModalVincularCliente(true);
        setSelectedDireccion(direc);
        getVinculedClients({direccion: direc, mail: mailClient})
    }

    return (
        <>
            <tr>
                <th className="text-center" scope="row">{i + 1}</th>
                <td className="text-center">{alias}</td>
                <td className="text-center">{barrio}</td>
                <td className="text-center">{codCiudad}</td>
                <td className="text-center">{codDepartamento}</td>
                <td className="text-center">{direccion}</td>
                <td className="text-center">{direccionID}</td>
                <td className="text-center">{esDireccionPredeterminada ? "Si" : "No"}</td>
                <td className="text-center">{mailClient || "Sin Asignar"}</td>

                {myAbilities.hasAny([C.A.DIRECTION.LINK, C.A.DIRECTION.UPDATE, C.A.DIRECTION.DELETE]) && <td className="text-center d-flex">
                    {myAbilities.has(C.A.DIRECTION.LINK) &&

                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Vincular Cliente</Tooltip>}>
                            <button type="button"
                                className="btn btn-sm btn-info me-2"
                                onClick={handleLinkClient}>
                                <i className="bi bi-person-fill" />
                            </button>
                        </OverlayTrigger>}

                    {myAbilities.has(C.A.DIRECTION.UPDATE) &&
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Editar</Tooltip>}>
                            <button type="button"
                                className="btn btn-sm btn-success me-2"
                                onClick={handleIsUpdateForm}>
                                <i className="bi bi-pencil-square" />
                            </button>
                        </OverlayTrigger>}

                    {myAbilities.has(C.A.DIRECTION.DELETE) &&
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Eliminar</Tooltip>}>
                            <button type="button"
                                className="btn btn-sm btn-danger me-2"
                                onClick={handleDeleteDireccion}>
                                <i className="bi bi-trash" />
                            </button>
                        </OverlayTrigger>}

                    <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Ver Datos Restantes</Tooltip>}>
                        <button type="button"
                            className="btn btn-sm btn-warning"
                            onClick={() => setModalMoreInfoDirection(true)}
                        >
                            <i className="bi bi-plus-circle-fill"></i>
                        </button>
                    </OverlayTrigger>
                </td>}
            </tr>


            <Modal
                show={modalMoreInfoDirection}
                onHide={() => setModalMoreInfoDirection(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                    Datos Restantes
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{"overflow": "auto"}}>
                <ListGroup>
                    <ListGroup.Item><strong>Observación: </strong>{observacion}</ListGroup.Item>
                    <ListGroup.Item><strong>Tipo Dirección ID: </strong>{tipoDireccionID ? "1" : "0"}</ListGroup.Item>
                    <ListGroup.Item><strong>Calle: </strong>{calle || "Sin Especificar"}</ListGroup.Item>
                    <ListGroup.Item><strong>Carrera: </strong>{carrera || "Sin Especificar"}</ListGroup.Item>
                    <ListGroup.Item><strong>Numero: </strong>{numero || "Sin Especificar"}</ListGroup.Item>
                    <ListGroup.Item><strong>Tipo Inmueble: </strong>{tipoInmueble || "Sin Especificar"}</ListGroup.Item>
                    <ListGroup.Item><strong>Numero Tipo inmueble: </strong>{numeroTipoInmueble || "Sin Especificar"}</ListGroup.Item>
                    <ListGroup.Item><strong>Bloque Interior: </strong>{bloqueInterior || "Sin Especificar"}</ListGroup.Item>
                    <ListGroup.Item><strong>Numero Bloque Interior: </strong>{numeroBloqueInterior || "Sin Especificar"}</ListGroup.Item>
                    <ListGroup.Item><strong>Codigo Direccion MER: </strong>{codigoDireccionMER || "Sin Especificar"}</ListGroup.Item>
                    <ListGroup.Item><strong>Tipo Direccion MER: </strong>{tipoDireccionMER || "Sin Especificar"}</ListGroup.Item>
                </ListGroup>
                </Modal.Body>    
            </Modal>
        </>
    )
}
export default Item